import { EnvMicroKlamIam } from 'lib-klab-core';

export const envKlabIamLocal: EnvMicroKlamIam = {
  host: '',
  apiBasePath: '/ms-iam',
  vars: {},
  useMocks: false,
  mock: {
    auth: {
      login: false,
      logout: false,
      refreshToken: false,
      validateToken: false,
    },
    passwordRecovery: {
      generateVerificationToken: false,
      validateVerificationToken: false,
      resetPassword: false,
    },
    roles: {
      getAll: false,
      getById: false,
      create: false,
      update: false,
      delete: false,
      listPermissions: false,
    },
  },
};

export const envKlabIamDev: EnvMicroKlamIam = {
  host: 'https://gatewayapi-dev.klab.inclub.world',
  apiBasePath: '/ms-iam',
  vars: {},
  useMocks: false,
  mock: {
    auth: {
      login: false,
      logout: false,
      refreshToken: false,
      validateToken: false,
    },
    passwordRecovery: {
      generateVerificationToken: false,
      validateVerificationToken: false,
      resetPassword: false,
    },
    roles: {
      getAll: false,
      getById: false,
      create: false,
      update: false,
      delete: false,
      listPermissions: false,
    },
  },
};

export const envKlabIamProd: EnvMicroKlamIam = {
  host: 'https://gatewayapi.klab.inclub.world',
  apiBasePath: '/ms-iam',
  vars: {},
  useMocks: false,
};
